import { render, staticRenderFns } from "./violationHandler.vue?vue&type=template&id=719d5a61&scoped=true&"
import script from "./violationHandler.vue?vue&type=script&lang=js&"
export * from "./violationHandler.vue?vue&type=script&lang=js&"
import style0 from "./violationHandler.vue?vue&type=style&index=0&id=719d5a61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719d5a61",
  null
  
)

export default component.exports